// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconNumber1 = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M12 4a8 8 0 100 16 8 8 0 000-16M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12"
    />,
    <path d="M13.137 6.948h-1.456c-.126 1.12-.896 1.582-2.548 1.582h-.21v1.274h2.492V17h1.722z" />
  );
export default SvgIconNumber1;
